import * as React from "react"
import {ToggleButtonSeeker} from "@ui-seeker/core";

import { SELLER_DETAILS_KPI } from "./@constants"
import {sellerDetailsKpi} from "./@signals";



const OPTIONS = [
	{ value: SELLER_DETAILS_KPI.SELLER, label: 'Seller details' },
	{ value: SELLER_DETAILS_KPI.PRODUCT, label: 'Product details' }
]

export default function MarketplacesSellerProductDetailsToggleButton() {
    return <ToggleButtonSeeker
        value={sellerDetailsKpi.value}
        onChange={(_, newValue) => sellerDetailsKpi.value = newValue}
		tabs={OPTIONS}
    />
}